// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__9tRxF","heading":"style_heading__3qp20","title":"style_title__283AJ","body":"style_body__2uz3y"};